
function capitalize(str)
{
	// match non-ASCII characters as well
	return str.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())
}


export default capitalize